var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 0.125C2.80273 0.125 0 2.92773 0 6.375V37.625C0 41.0723 2.80273 43.875 6.25 43.875H37.5C40.9473 43.875 43.75 41.0723 43.75 37.625V6.375C43.75 2.92773 40.9473 0.125 37.5 0.125H6.25ZM35.2637 8.32812L25.127 19.9102L37.0508 35.6719H27.7148L20.4102 26.1113L12.041 35.6719H7.40234L18.2422 23.2793L6.80664 8.32812H16.377L22.9883 17.0684L30.625 8.32812H35.2637ZM31.5723 32.8984L14.9805 10.9551H12.2168L28.9941 32.8984H31.5625H31.5723Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.293855293a296ba026b091cae4b5af05.svg";
export { ForwardRef as ReactComponent };